import React, { useEffect, useState } from "react";
import AllQuestions from "./QuestionTypes/AllQuestions";
import { useSelector } from "react-redux";
import axios from "../../../axios";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import { SubjectIcon } from "../../../SubjectIcon";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

export default function OnreviewAss({ filter }) {
  const [onReviewAss, setOnReview] = useState({
    assReview: false,
    assessmentId: null,
  });

  const [reviewCard, setReviewCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const { state } = useLocation();

  useEffect(() => {
    const reviewBox = async () => {
      try {
        let response = await axios.get(
          `/assessment/filterByStudentId/${currentUser?.id}/review?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
            `${
              filter?.date
                ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
                : ``
            }` +
            `${filter?.time ? `&time=${filter?.time}` : ``}` +
            `${
              filter?.subjectId?.length !== 0
                ? `&subjectId=${filter?.subjectId}`
                : ``
            }`
        );

        response && setReviewCard(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    reviewBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleQuestionfalse = () => {
    setOnReview({
      ...onReviewAss,
      assReview: false,
    });
  };

  return (
    <div>
      {reviewCard && reviewCard.length > 0 ? (
        <div className="totalPenadingAssContainer">
          <div className="d-flex gap-4 mt-3 flex-wrap">
            {reviewCard?.map((item, index) => (
              <>
                <Link
                  className="link"
                  to={`/Assessment/review/questions`}
                  state={{ assessmentId: item?.id }}
                >
                  {/* <div
                    className="containerForPendinDeatailAss p-3 "
                    onClick={(e) =>
                      setOnReview({
                        ...onReviewAss,
                        assReview: true,
                        assessmentId: item?.id,
                      })
                    }
                    key={index}
                  >
                    <div className="kannadaHeaderAss">{item?.subject?.name}</div>
                    <div className="headingOfAss mt-2">{item?.name}</div>
                    <span className="deadlineAss">Submitted</span> &nbsp;
                    <span className="deadlineDateAss">
                      {timeHelper(item?.submitted_on)}
                    </span>
                  </div> */}
                  <div
                    key={index}
                    // className="summarySubBoxContainerHW"
                    className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                    style={{
                      borderTop: `8px solid #${item?.subject?.subject_color}`,
                    }}
                    onClick={(e) =>
                      setOnReview({
                        ...onReviewAss,
                        assReview: true,
                        assessmentId: item?.id,
                      })
                    }
                  >
                    <div className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center">
                      <div>
                        <div className="subboxSubjectName">
                          {item?.subject?.name}
                        </div>
                      </div>
                      <div>
                        <img
                          src={`${
                            SubjectIcon?.find(
                              (i) => i.subjectName === item?.subject?.name
                            )?.icon
                          }`}
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      className="SubsummarySubBoxContainer"
                      style={{ paddingTop: "0" }}
                    >
                      <div className="headingOfHW" title={item?.name}>
                        {
                          <Tooltip
                            title={item?.name}
                            arrow
                            placement="bottom"
                            enterDelay={200}
                            leaveDelay={100}
                          >
                            <div className="flex">
                              <BookText
                                size={16}
                                className="me-2 mt-1 text-dark"
                              />
                              {shortenParagraph(item?.name, 30)}
                            </div>
                          </Tooltip>
                        }
                      </div>
                      <div className="flex mt-2">
                        <CalendarDays size={16} className="me-2 text-dark" />
                        <span className="deadline">Submitted:</span> &nbsp;
                        <span className="deadlineDate">
                          {moment(item?.submitted_on)
                            .local()
                            .format("DD-MM-YYYY")}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </>
            ))}
          </div>

          {/* {onReviewAss.assReview && (
            <AllQuestions
              assessmentId={onReviewAss?.assessmentId}
              handleQuestionfalse={handleQuestionfalse}
            />
          )} */}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-20 w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            🧾 Assessment Not Found
          </span>
        </div>
      )}
    </div>
  );
}
